export class Clock {
  private last = performance.now();

  reset() {
    this.last = performance.now();
  }

  tick(): number {
    const now = performance.now();
    const dt = (now - this.last) / 1000;
    this.last = now;
    return Math.min(Math.max(dt, 0), 1 / 15);
  }
}
